import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
export const Input = React.forwardRef(function Input({ className, type = "text", ...props }, ref) {
    return _jsx("input", { ref: ref, type: type, className: cn("ui-input", className), ...props });
});
export const Textarea = React.forwardRef(function Textarea({ className, ...props }, ref) {
    return _jsx("textarea", { ref: ref, className: cn("ui-input ui-textarea", className), ...props });
});
export const Select = React.forwardRef(function Select({ className, ...props }, ref) {
    return _jsx("select", { ref: ref, className: cn("ui-input ui-select", className), ...props });
});
export function FieldGroup({ className, ...props }) {
    return _jsx("div", { className: cn("ui-field-group", className), ...props });
}
export function Field({ className, ...props }) {
    return _jsx("div", { className: cn("ui-field", className), ...props });
}
export function FieldLabel({ className, ...props }) {
    return _jsx("label", { className: cn("ui-label", className), ...props });
}
export function FieldDescription({ className, ...props }) {
    return _jsx("p", { className: cn("ui-field-description", className), ...props });
}
export function FieldError({ className, ...props }) {
    return _jsx("p", { role: "alert", className: cn("ui-field-error", className), ...props });
}
export function FieldSet({ className, ...props }) {
    return _jsx("fieldset", { className: cn("ui-field-group", className), ...props });
}
export function FieldLegend({ className, ...props }) {
    return _jsx("legend", { className: cn("ui-label", className), ...props });
}
//# sourceMappingURL=form.js.map